import React from 'react';
import styled from 'styled-components';

export interface Props {
  tag?: string;
  [propName: string]: any;
}

const DynamicText = ({ tag = 'span', ...props }: Props) => {
  const Tag = tag;
  return <Tag {...props} />;
};

/**
 * Renders text with dynamic tagname
 * Taken from https://github.com/AudaxHealthInc/telemedicine-components/blob/main/src/Typography/Text.tsx
 */
export const Text = styled(DynamicText)`
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  text-size-adjust: none;
`;
